import styled, { css } from '@app/styled';
import { oneLineEllipsis } from '@app/styles';
import { color, modifier, radius, spacing, typography } from '@app/theme';

type EmailProps = {
    $invalid: boolean;
};

export const EmailWrapper = styled.div<EmailProps>`
    ${typography('custom.description')};
    color: ${color('custom.content.primary')};

    background-color: ${color('custom.background.secondary')};
    padding: ${spacing(1, 1, 1, 2)};
    border-radius: ${radius('m')};

    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 25px;
    max-width: 250px;
    border: 1px solid ${color('custom.background.secondary')};

    ${modifier(
        '$invalid',
        css`
            background-color: transparent;
            border-color: ${color('custom.interactive.red.idle')};
        `,
    )}
`;

export const Email = styled.span<EmailProps>`
    padding-bottom: 1px;

    ${oneLineEllipsis}

    ${modifier(
        '$invalid',
        css`
            color: ${color('custom.interactive.red.idle')};
        `,
    )}
`;

export const EmailRemove = styled.span`
    background-color: transparent;
    border: none;
    display: flex;
    align-items: center;
    cursor: pointer;
    padding: ${spacing(1, 0, 1, 1)};
`;
